import { _fetch as fetchSecure } from '@hobs/utils/fetch';
import {
  CREATE,
  GET,
  CLEAR,
  EDIT,
  DELETE,
  FORSUBMIT
} from '@hobs/constants/catalogItem';

export function createCatalogItem(catalogItem) {
  return dispatch => {
    dispatch(request());
    return fetchSecure('catalogItems', { body: catalogItem, method: 'POST' })
      .then(response => {
        if (response.status === 200) {
          dispatch(success());
          return { success: true, ...response };
        } else {
          dispatch(failure(response.toString()));
          return { success: false, ...response };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: CREATE.REQUEST };
  }
  function success() {
    return { type: CREATE.SUCCESS };
  }
  function failure(error) {
    return { type: CREATE.FAILURE, error };
  }
}

export function getCatalogItem(catalogItemId) {
  return dispatch => {
    dispatch(request());
    return fetchSecure(`catalogItems/${catalogItemId}`)
      .then(response => {
        if (response.status === 200) {
          dispatch(success(response.payload));
          return { success: true, ...response };
        } else {
          dispatch(failure(response.toString()));
          return { success: false, ...response };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: GET.REQUEST };
  }
  function success(response) {
    return { type: GET.SUCCESS, response };
  }
  function failure(error) {
    return { type: GET.FAILURE, error };
  }
}

export function clearCatalogItem() {
  return dispatch => {
    dispatch({ type: CLEAR.SUCCESS });
  };
}

export function editCatalogItem(catalogItem) {
  return dispatch => {
    dispatch(request());
    return fetchSecure('catalogItems', { body: catalogItem, method: 'PUT' })
      .then(response => {
        if (response.status === 200) {
          dispatch(success());
          return { success: true };
        } else {
          dispatch(failure(response.toString()));
          return { success: false, ...response };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: EDIT.REQUEST };
  }
  function success() {
    return { type: EDIT.SUCCESS };
  }
  function failure(error) {
    return { type: EDIT.FAILURE, error };
  }
}

export function deleteCatalogItem(catalogItemId) {
  return dispatch => {
    dispatch(request());
    return fetchSecure(`catalogItems/${catalogItemId}`, { method: 'DELETE' })
      .then(response => {
        if (response.status === 200) {
          dispatch(success());
          return { success: true };
        } else {
          dispatch(failure(response.toString()));
          return { success: false, ...response };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
    function request() {
      return { type: DELETE.REQUEST };
    }
    function success() {
      return { type: DELETE.SUCCESS };
    }
    function failure(error) {
      return { type: DELETE.FAILURE, error };
    }
  };
}

export function getCatalogItemForSubmit() {
  return dispatch => {
    dispatch(request());
    return fetchSecure('catalogItems/forSubmit')
      .then(response => {
        if (response.status === 200) {
          dispatch(success(response.payload));
          return { success: true, ...response };
        } else {
          dispatch(failure(response.toString()));
          return { success: false, ...response };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: FORSUBMIT.REQUEST };
  }
  function success(response) {
    return { type: FORSUBMIT.SUCCESS, response };
  }
  function failure(error) {
    return { type: FORSUBMIT.FAILURE, error };
  }
}
